export default (payload) => ({
    name: payload[0].name,
    description: payload[0].description,
});
